var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#00AEEF;}\n\t.st3{font-family:'Momcake-Bold';}\n\t.st4{font-size:131.8039px;}\n\t.st5{fill:#137392;}\n\t.st6{font-size:58px;}\n\t.st7{letter-spacing:5;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_5_",
    transform: "matrix(1 0 0 1 246.2237 828.577)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3 st4"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.8,
    y: 0,
    className: "st5 st3 st4"
  }, "KILL"), /*#__PURE__*/React.createElement("tspan", {
    x: 266.4,
    y: 0,
    className: "st2 st3 st4"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 342,
    y: 0,
    className: "st5 st3 st4"
  }, "YUH"), /*#__PURE__*/React.createElement("tspan", {
    x: -0.5,
    y: 69.6,
    className: "st5 st3 st6 st7"
  }, "INCULCATING SKILLS")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st1",
    d: "M921.6,244.2L549,29.1c-19.7-11.4-44.2-11.4-63.9,0L112.5,244.2 c-19.7,11.4-31.9,32.6-31.9,55.3v430.3c0,22.8,12.2,44,31.9,55.3l372.6,215.1c9.9,5.7,20.9,8.5,31.9,8.5s22.1-2.8,31.9-8.5 l372.6-215.1c19.7-11.4,31.9-32.6,31.9-55.3V299.5C953.5,276.8,941.3,255.6,921.6,244.2z M505.1,63.7c3.7-2.1,7.8-3.2,11.9-3.2 s8.3,1.1,11.9,3.2l369.6,213.4l-98.5,56.8c-4.2-4.4-9-8.2-14.3-11.3L549,185.9c-19.7-11.4-44.2-11.4-63.9,0L248.3,322.6 c-5.4,3.1-10.2,6.9-14.3,11.3l-98.5-56.8L505.1,63.7z M529,808.8c-7.4,4.3-16.5,4.3-23.9,0L273.9,675.3l243.7-140.7l242.7,140.7 L529,808.8z M777.7,644.9L534.5,504V223.8l231.2,133.5l0,0c7.4,4.3,11.9,12.2,11.9,20.7V644.9z M256.4,645V378 c0-8.5,4.6-16.4,11.9-20.7l231.2-133.5v280.8L256.4,645z M132.5,750.5c-7.4-4.3-11.9-12.2-11.9-20.7V303.1l98.5,56.8 c-1.7,5.8-2.6,11.9-2.6,18v273.4c0,22.8,12.2,44,31.9,55.3l236.8,136.7c5.4,3.1,11.1,5.3,16.9,6.8v113.7L132.5,750.5z M901.6,750.5 L532,963.9V850.2c5.9-1.4,11.6-3.7,16.9-6.7l236.8-136.7c19.7-11.4,31.9-32.6,31.9-55.3V378c0-6.2-0.9-12.3-2.6-18l98.5-56.8v426.7 C913.5,738.3,908.9,746.2,901.6,750.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st8",
    d: "M922.6,238.1L922.6,238.1L550,23c-19.7-11.4-44.2-11.4-63.9,0L113.5,238.1 c-19.7,11.4-31.9,32.6-31.9,55.3v430.3c0,22.8,12.2,44,31.9,55.3l372.6,215.1c9.9,5.7,20.9,8.5,31.9,8.5c11,0,22.1-2.8,31.9-8.5 l372.6-215.1c19.7-11.4,31.9-32.6,31.9-55.3V293.5C954.6,270.7,942.4,249.5,922.6,238.1z M506.1,57.7c3.7-2.1,7.8-3.2,11.9-3.2 c4.1,0,8.3,1.1,11.9,3.2L899.6,271l-98.5,56.8c-4.2-4.4-9-8.2-14.3-11.3L550,179.9c-19.7-11.4-44.2-11.4-63.9,0L249.4,316.6 c-5.4,3.1-10.2,6.9-14.3,11.3L136.6,271L506.1,57.7z M530,802.7c-7.4,4.3-16.5,4.3-23.9,0L274.9,669.2l243.7-140.7l242.7,140.7 L530,802.7z M778.8,638.8L535.6,497.9V217.7l231.2,133.5c7.4,4.3,11.9,12.2,11.9,20.7V638.8z M257.4,638.9v-267 c0-8.5,4.6-16.4,11.9-20.7l231.2-133.5v280.8L257.4,638.9z M133.5,744.4c-7.4-4.3-11.9-12.2-11.9-20.7V297l98.5,56.8 c-1.7,5.8-2.6,11.9-2.6,18v273.4c0,22.8,12.2,44,31.9,55.3l236.8,136.7c5.4,3.1,11.1,5.3,16.9,6.8v113.7L133.5,744.4z M902.6,744.4 L533.1,957.8V844.1c5.9-1.4,11.6-3.7,16.9-6.8l236.8-136.7c19.7-11.4,31.9-32.6,31.9-55.3V371.9c0-6.2-0.9-12.3-2.6-18l98.5-56.8 v426.7C914.6,732.2,910,740.2,902.6,744.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af0b45a20658d8e4014b0956f529b55a.svg";
export { ForwardRef as ReactComponent };